const radioStyles = theme => ({
  '.radio-wrapper': {
    display: 'flex',
    alignItems: 'center',
  },

  // Force override of styles from AntD
  "form input[type='radio'].radio": {
    width: '18px',
    height: '18px',
  },

  '.radio': {
    width: '18px',
    height: '18px',
    flex: '0 0 auto',

    '&:focus': {
      outline: 'none',
    },
  },

  '.radio-dark': {
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.65')}`,

    '&:focus:not(:checked)': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.65')}`,
    },

    '&:checked:before': {
      backgroundColor: theme('colors.green1.65'),
    },

    '&:disabled': {
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.35')}`,
    },

    '&:checked:disabled:before': {
      backgroundColor: theme('colors.green1.35'),
    },
  },

  '.radio-light': {
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.10')}`,

    '&:focus:not(:checked)': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.10')}`,
    },

    '&:checked:before': {
      backgroundColor: theme('colors.green1.10'),
    },

    // TODO: disabled styles
  },

  '.radio-label': {
    color: theme('colors.grey.75'),

    '.radio-peer:disabled ~ &': {
      color: theme('colors.grey.40'),
    },
  },
});

module.exports = { radioStyles };
